// Angular Files
import { Injectable } from '@angular/core';

// Other External Files
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

// Teller Online Files
import {
    ActiveAuthorizationTextDto,
    AuthorizationTextApiClient,
    PaymentAuthorizationTypeEnumDto,
    PaymentMethodTypeEnumDto
} from 'apps/public-portal/src/app/core/api/PublicPortalApiClients';

/**
 * Thin wrapper over the generated `AuthorizationTextApiClient` for resolving
 * the active authorization-text version that the consent component should
 * display (TOP-2935). Returns `null` for the 204 "no active text" case
 * (legitimate only for Credit-card flows where no version cascades via the
 * AdHoc fallback chain).
 */
@Injectable({
    providedIn: 'root'
})
export class AuthorizationConsentService {
    constructor(
        private apiClient: AuthorizationTextApiClient
    ) {}

    public getActive(
        paymentMethodType: PaymentMethodTypeEnumDto,
        authorizationType: PaymentAuthorizationTypeEnumDto
    ): Observable<ActiveAuthorizationTextDto | null> {
        return this.apiClient.getActiveAuthorizationText(paymentMethodType, authorizationType)
            .pipe(
                // NSwag treats 204 as a success and produces `null`, but defensively
                // map any falsy result to null so callers can branch on a single shape.
                map(result => result ?? null),
                catchError(err => {
                    // 204 on Angular-side: some NSwag templates throw a parse error
                    // instead of resolving to null. If the server emitted 204, treat
                    // it as "no active text" rather than propagating an error to the
                    // consent component (which would block the whole flow for the
                    // legitimate "Credit no-op" case).
                    if (err?.status === 204) return of(null);
                    throw err;
                })
            );
    }
}
